import { Component, Output, EventEmitter } from '@angular/core';
import { FeedbackService } from './feedback.service';
import { IFeedback } from '../models/feedback';
import { Translations } from '../shared/translations';
import { I18nSelectPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'feedback',
  templateUrl: 'feedback.component.html',
  styleUrls: ['feedback.component.scss'],
  imports: [I18nSelectPipe, FormsModule],
  providers: [FeedbackService]
})
export class FeedbackComponent {
  translations = Translations;
  feedback: IFeedback;
  readonly maxMessageLength = 2000;

  @Output() feedbackClosed = new EventEmitter();

  constructor(private feedbackService: FeedbackService) {
    this.feedback = {
      browserName: '',
      currentScreenResolution: '',
      currentUrl: '',
      message: ''
    };
  }

  submitFeedback(): void {
    const message = this.feedback.message?.trim();
    if (!message || message.length > this.maxMessageLength) {
      return;
    }

    this.feedback.message = message;
    this.feedback.browserName = navigator.userAgent;
    this.feedback.currentUrl = window.location.href;
    this.feedback.currentScreenResolution = `${screen.width}x${screen.height}`;

    this.feedbackService
      .submitFeedback(this.feedback)
      .subscribe(() => {
        this.cancel();
      });
  }

  cancel(): void {
    this.feedback.message = '';
    this.feedbackClosed.emit();
  }
}
